import { render } from "./AppLoader.vue?vue&type=template&id=c9e28890"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=c9e28890&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__